<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">

    <!-- タイトル -->
    <div class="p-d-flex p-jc-center title">
      <div>
        <label>地方創生SDGs官民連携プラットフォーム</label><br />
        <label class="p-d-flex p-jc-center title-name">分科会 </label>
      </div>
    </div>

    <!-- 見出し -->
    <div class="info-title">
      <h1>
        <label>分科会参加登録の確認</label>
      </h1>
    </div>
    
    <!-- 分科会参加登録情報 -->
    <div class="subcommittee-information">
      <!-- 備考 -->
      <div class="note">
        <label>
          以下の情報が分科会の主催・窓口に提供されます。内容を確認・同意の上、「登録」ボタンをクリックしてください。<br />
          登録内容に変更がある場合は、マイページ内の「<a [routerLink]="" (click)="moveToView('profile')">会員プロフィール管理</a>」及び「<a [routerLink]="" (click)="moveToView('b220')">ユーザー管理</a>」より更新が可能です。<br />
        </label>
      </div>
      
      <!-- 分科会登録内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 団体名称 -->
          <tr>
            <td class="item-name">団体名称</td>
            <td class="item-information">{{ loginUser?.organization_name }}</td>
          </tr>
          <!-- 氏名 -->
          <tr>
            <td class="item-name">氏名</td>
            <td class="item-information">{{ loginUser?.full_name }}</td>
          </tr>
          <!-- メールアドレス -->
          <tr>
            <td class="item-name">メールアドレス</td>
            <td class="item-information">{{ loginUser?.email }}</td>
          </tr>
          <!-- 本プラットフォーム -->
          <tr>
            <td class="item-name">本プラットフォームにおける活動で<br>実現したいこと</td>
            <td class="item-information">{{ memberInformation?.want }}</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="information-margin-height"></div>

      <!-- チェックボックス -->
      <div class="p-d-flex p-jc-center">
        <p-checkbox
          [value]="'checked'"
          label="情報提供に同意の上、参加します。"
          [(ngModel)]="agreeCheck"
          (click)="setAgreeCheck()"
        ></p-checkbox>
      </div>

      <div class="information-margin-height"></div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button
          pButton
          type="button"
          label="登録"
          [disabled]="!agreeCheckFlag"
          (click)="joinSubcommittee()"
          class="button-default-size button1"
        ></button>
        <button
          pButton
          type="button"
          label="キャンセル"
          (click)="moveToView('e202')"
          class="button-default-size button2"
        ></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
